// extracted by mini-css-extract-plugin
module.exports = {"layout":"Layout_layout__xvC8B","customBg":"Layout_customBg__4LTgZ","content":"Layout_content__hZcBN"};